require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./croquignole-et-croqcinelle-1-1-16-0.json") })
        }
      }, "path---croquignole-et-croqcinelle-1-1-16-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---croquignole-et-croqcinelle-1-1-16-0!./.cache/json/croquignole-et-croqcinelle-1-1-16-0.json
// module id = 390
// module chunks = 231608221292675